__turbopack_context__.v({
  "productItem": "s-f27a_productItem",
  "productList": "s-f27a_productList",
  "unavailableProductsList": "s-f27a_unavailableProductsList",
  "unavailableProductsTitle": "s-f27a_unavailableProductsTitle",
});
